<ui-side-sheet>
  @if (config(); as config) {
    <div class="page">
      <div class="page-container">
        <ui-agent-status-bar></ui-agent-status-bar>

        <div class="sticky-header">
          @if (config.modal) {
            <ui-advertising-modal-content [data]="config.modal"></ui-advertising-modal-content>
          }

          @if (config.infobar) {
            <ui-info-bar-content [data]="config.infobar"></ui-info-bar-content>
          }

          @if (slots.header; as headerComponent) {
            <ng-container *ngComponentOutlet="headerComponent; inputs: { config }"></ng-container>
          } @else {
            <ui-cep-header></ui-cep-header>
          }
        </div>

        @if (!slots.header && showDesktopNavigation()) {
          <div class="primary-navigation">
            <ui-desktop-navigation></ui-desktop-navigation>
          </div>
        }

        <main class="main">
          <router-outlet></router-outlet>
        </main>

        @if (slots.footer; as footerComponent) {
          <ng-container *ngComponentOutlet="footerComponent; inputs: { config }"></ng-container>
        } @else {
          <ui-footer
            [data]="config.footer"
            [legalNav]="config.navigation.Legal"
            [copyright]="config.company.copyright"
          ></ui-footer>
        }

        <div class="bottom-actions">
          @if (options.showMobileBottomNavigation !== false && !isDesktop()) {
            <ui-navbar></ui-navbar>
          }

          <ui-scroll-top [label]="config.translations?.scrollToTop"></ui-scroll-top>
        </div>
      </div>
    </div>
  } @else {
    <ui-cms-skeleton></ui-cms-skeleton>
  }
</ui-side-sheet>
